angular.module('unergie.main')
.directive('salesTunnelPrmV3', ($q, $timeout, mapUtils, DraftsBasic, AlertManager, BoFeaturesService, ModalService, ApiUser, ReferencesService, ApiAdmin,
    MetaWatcher, AuthService, LandscapeQuestions, ErrorCatcher, OfferService) => ({
    restrict: 'E',
    scope: {
        draft: '=',
        landscape: '=',
        disableContractEdition: '=',
    },
    templateUrl: '/states/salesTunnelV3/component/salesTunnelPrmV3.html',
    link($scope) {
        $scope.seniorAdvisor = BoFeaturesService.isFeatureOn('seniorAdvisor')
        $scope.canSeeFTA = BoFeaturesService.isFeatureOn('canSeeFTA')
        $scope.saveDraft = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_DRAFT')
        $scope.reloadDraft = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.RELOAD_DRAFT')
        $scope.savePrm = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_PRM')
        $scope.showTools = !BoFeaturesService.get('isEnvProd')
        $scope.prmMode = BoFeaturesService.isFeatureOn('sgeSearch')
        $scope.disableDraftInterestScoring = BoFeaturesService.isFeatureOn('disableDraftInterestScoring')
        $scope.fetching = false
        $scope.redirectUrl = false
        $scope.withoutPrm = false
        $scope.postCodes = []
        $scope.commune = $scope.draft.bill_addr_post_code

        $scope.enedisConsent = false

        $scope.prm = {
            id_prm: $scope.draft.draftElec.id_prm,
            previous_id_prm: null,
            prmResult: undefined,
            plan_id: undefined,
            id_p_calendar: undefined,
        }
        $scope.hints = []
        $scope.form = {
            choosen_id_p_calendar: $scope.draft.draftElec.choosen_id_p_calendar,
            choosen_max_power: $scope.draft.draftElec.choosen_max_power,
        }
        $scope.tools = {
            displayChoosen: false,
        }
        $scope.heatings = [
            { value: 'electric_heating', label: 'Chauffage éléctrique' },
            { value: 'collective_heating', label: 'Chauffage collectif' },
            { value: 'gas_heating', label: 'Chauffage au gaz' },
            { value: 'other', label: 'Autre' },
        ]

        let availablePowers = []
        $scope.powers = [{ id: null, label: '-- Choisissez --' }]
        $scope.calendarIds = [{ id: null, label: '-- Choisissez --' }]

        $scope.isAdmin = () => AuthService.userHasGroup(['data-admin', 'data-reader'])


        $scope.idPCalendarTooltip = `Il existe deux options tarifaires :<ul>` +
            `<li>L'option <b>Base</b> : le prix du kWh est identique quelle que soit l'heure</li>` +
            `<li>L'option <b>Heures pleines / Heures creuses (HP/HC)</b> : le prix du kWh est plus bas durant les creuses.</li></ul>`

        $scope.maxPowerTooltip = `La Puissance souscrite correspond à la capacité qu'a votre compteur de supporter l'utilisation de vos appareils électriques en <i>même temps</i>.` +
            ` Lorsque la puissance souscrite est dépassée le logement risque de disjoncter. Il est donc important de souscrire à une puissance correspondant aux besoins de votre logement.`

        // VALIDATORS
        const initComponentValidator = () =>
            MetaWatcher.notif('SALES_TUNNEL.SET_VALIDATORS', {
                isPrmValid(store) {
                    return !!store.draft.draftElec.id_prm && (!$scope.seniorAdvisor || !(store.draft.draftElec.prm_search_called && !store.draft.draftElec.prm_search_hint))
                },
                isPrmEligible(store) {
                    return !!(store.prm.prmResult && store.prm.prmResult.eligible)
                },
                isMaxPowerDefined(store) {
                    return (!!store.draft.draftElec.max_power || !!store.draft.draftElec.choosen_max_power)
                },
                isIdPCalendarDefined(store) {
                    return (!!store.draft.draftElec.id_p_calendar || !!store.draft.draftElec.choosen_id_p_calendar)
                },
                isPrmSearchHintValid(store) {
                    return !$scope.seniorAdvisor || !store.draft.draftElec.prm_search_called || !_.isNil(store.draft.draftElec.prm_search_hint)
                },
                isPrimaryResidenceDefined(store) {
                    return _.isBoolean(store.draft.primary_residence) || store.draft.account_category === 'small-business'
                },
                isHeatingDefined(store) {
                    return !_.isEmpty(store.draft.heating)
                },
            })

        $scope.isRequiredLandscapeDone = () => {
            return $scope.landscape.landscapeRequired === true && $scope.landscape.landscapeDone === true
        }

        // PRM Generator
        $scope.$on('prmSelected', (e, idPrm) => {
            $scope.prm = {
                id_prm: idPrm,
                previous_id_prm: $scope.prm.previous_id_prm,
                eligible: null,
                prmResult: undefined,
                plan_id: undefined,
                id_p_calendar: undefined,
            }
            $scope.prmChanged()
            $scope.fetchPrm()
        })

        // Hints values
        ReferencesService.getRef('searchHints').then((mapping) => {
            $scope.hints = mapping
        })

        $scope.toggleWithoutPrm = () => {
            $scope.withoutPrm = true
            if (!$scope.postCodes.length) {
                ReferencesService.getRef('inseepostcode', true).then((mapping) => {
                    $scope.postCodes = mapping
                })
            }
        }
        if (!$scope.prm.id_prm && !$scope.prm.prmResult && $scope.draft.bill_addr_post_code) {
            $scope.toggleWithoutPrm()
        }

        $scope.selectPostCode = function (commune) {
            if (commune) {
                $scope.draft.bill_addr_post_code = commune.postcode
                $scope.draft.bill_addr_city_code = commune.insee_code
            }
            $scope.saveDraft(_.pick($scope.draft, ['bill_addr_post_code', 'bill_addr_city_code']))
        }

        // TODO - Not required to update saveDraft on each keypress
        $scope.prmChanged = function () {
            $scope.savePrm($scope.prm)
            $scope.saveDraft({ draftElec: { id_prm: null, prm_search_called: false, prm_search_hint: null, heating: null, primary_residence: null } })
        }

        $scope.prmDataAvailable = () => {
            return $scope.prm.eligible &&
                ($scope.prm.prmResult.power.max || $scope.form.choosen_max_power) &&
                ($scope.prm.prmResult.plan.id_p_calendar || $scope.form.choosen_id_p_calendar)
        }

        // Choosen PRM data
        const initChoosenMaxPowerData = () => {
            if ($scope.draft.draftElec.max_power === $scope.draft.draftElec.choosen_max_power) {
                delete $scope.draft.draftElec.choosen_max_power
            }
            $scope.powers = [{ id: null, label: $scope.draft.draftElec.max_power ? `-- Pas de modification --` : '-- Choisissez --' }]
            const calendar = $scope.form.choosen_id_p_calendar ?
                availablePowers[$scope.form.choosen_id_p_calendar] :
                availablePowers[_.get($scope.prm, 'prmResult.plan') ? $scope.prm.prmResult.plan.id_p_calendar : undefined]
            if (calendar) {
                $scope.powers = $scope.powers.concat(calendar.availablePowers.map((p) => ({ id: p, label: `${p}kVA` })))
                if ($scope.draft.draftElec.max_power) {
                    _.remove($scope.powers, { id: $scope.draft.draftElec.max_power })
                }
                if (!_.find($scope.powers, { id: $scope.form.choosen_max_power })) {
                    $scope.form.choosen_max_power = $scope.powers[0].id
                }
            }
        }

        $scope.fetchPrm = function () {
            if (!$scope.enedisConsent) {
                return Promise.resolve()
            }
            $scope.fetching = true
            let landscapeFlush
            if ($scope.prm.previous_id_prm && $scope.prm.id_prm !== $scope.prm.previous_id_prm) {
                landscapeFlush = LandscapeQuestions.flush({ id_contract: $scope.draft.id.startsWith('VD') ? $scope.draft.id : $scope.draft.draftElec.id, draft: true }).$promise.then((result) => {
                    MetaWatcher.notif('SALES_TUNNEL.SAVE_LANDSCAPE', { landscapeDone: false, landscapeVersion: null })
                    return result
                })
            } else {
                landscapeFlush = $q.resolve()
            }
            landscapeFlush.then(() => {
                return ApiUser.eligibilityPRM({ id_prm: $scope.prm.id_prm, id_contract: $scope.draft.id.startsWith('VD') ? $scope.draft.id : $scope.draft.draftElec.id }).$promise
            }).then((prm) => {
                $scope.prm = {
                    id_prm: $scope.prm.id_prm,
                    previous_id_prm: $scope.prm.id_prm,
                    eligible: prm.eligible,
                    prmResult: prm.toJSON(),
                    plan_id: prm.eligible ? _.get(prm, 'plan.id') : undefined,
                    id_p_calendar: prm.eligible ? _.get(prm, 'plan.id_p_calendar') : undefined,
                    last_update: new Date().toISOString(),
                }

                if (['BTINFLU', 'BTINFLUSC'].includes(prm.routing_tariff)) {
                    prm.choosen_routing_tariff = ($scope.draft.draftElec.choosen_id_p_calendar || $scope.prm.id_p_calendar) === 'HPHC' ? 'BTINFMUDT' : 'BTINFCUST'
                }

                // Notify other component on fetched prm, valid or not
                $scope.savePrm($scope.prm)
                $scope.saveDraftOnEligiblePrm(prm)
                initChoosenMaxPowerData()
            }).catch((error) => {
                ErrorCatcher(error)
                $scope.prm = {
                    id_prm: $scope.prm.id_prm,
                    previous_id_prm: $scope.prm.previous_id_prm,
                    eligible: null,
                    prmResult: error,
                    plan_id: undefined,
                    id_p_calendar: undefined,
                    last_update: new Date().toISOString(),
                }
                $scope.savePrm($scope.prm)
            }).finally(() => {
                $scope.fetching = false
            })
        }

        $scope.saveDraftOnEligiblePrm = function (prm) {
            if (prm.eligible) {
                // Notify draft changed
                $scope.saveDraft({
                    addr_city_code: prm.addr.city_code,
                    addr_city_lbl: prm.addr.city_lbl,
                    addr_details: prm.addr.details,
                    addr_num_street: prm.addr.num_street,
                    addr_post_code: prm.addr.post_code,
                    is_a_move: ['MES', 'MES_INTER', 'FIRST_MES'].includes(prm.subscriptionType),
                    draftElec: {
                        plan_id: (prm.plan != null ? prm.plan.id : undefined),
                        id_p_calendar: (prm.plan != null ? prm.plan.id_p_calendar : undefined),
                        plan: (prm.plan != null ? prm.plan.label : undefined),
                        meter_kind: prm.metter.kind,
                        routing_tariff: prm.routing_tariff,
                        choosen_routing_tariff: prm.choosen_routing_tariff,
                        max_power: (prm.power != null ? prm.power.max : undefined),
                    },
                })
            } else {
                $scope.reloadDraft()
            }
        }

        // Search PRM by postal address
        $scope.searchPrm = () => {
            const payload = $scope.seniorAdvisor ? { light: false } : { is_a_move: $scope.draft.is_a_move }
            return ModalService.openModal({ type: $scope.seniorAdvisor ? 'prmSearchModal' : 'prmSearchBeginnerModal', size: 'xlg' }, payload, (result) => {
                $scope.prm = {
                    id_prm: result,
                    previous_id_prm: $scope.prm.previous_id_prm,
                    eligible: null,
                    prmResult: undefined,
                    plan_id: undefined,
                    id_p_calendar: undefined,
                    last_update: new Date().toISOString(),
                }
                $scope.savePrm($scope.prm)
                $scope.updateSearchHint()
                if ($scope.prm.id_prm.length === 14) {
                    $scope.fetchPrm()
                }
            })
        }

        $scope.updateSearchHint = function () {
            $scope.draft.draftElec.prm_search_called = true
            $scope.saveDraft({ draftElec: { prm_search_called: $scope.draft.draftElec.prm_search_called, prm_search_hint: $scope.draft.draftElec.prm_search_hint } })
        }

        // Initial data
        const initChoosenCalendarData = () =>
            ReferencesService.getRef('ot-ps').then((mapping) => {
                if ($scope.draft.draftElec.id_p_calendar === $scope.draft.draftElec.choosen_id_p_calendar) {
                    $scope.draft.draftElec.choosen_id_p_calendar = null
                }
                availablePowers = mapping.toJSON()
                $scope.calendarIds = [{ id: null, label: $scope.draft.draftElec.id_p_calendar ? '-- Pas de modification --' : '-- Choisissez --' }]
                .concat(_.map(availablePowers, (v, k) => ({ id: k, label: v.label })))
                if ($scope.draft.draftElec.id_p_calendar) {
                    _.remove($scope.calendarIds, { id: $scope.draft.draftElec.id_p_calendar })
                }
            })

        $scope.updateChoosenCalendarId = () => {
            initChoosenMaxPowerData()
            $scope.saveChoosenData()
        }

        $scope.changeModifyOffer = () => {
            if (!$scope.form.modify_offer) {
                if ($scope.draft.draftElec.id_p_calendar) {
                    $scope.form.choosen_id_p_calendar = null
                }
                if ($scope.draft.draftElec.max_power) {
                    $scope.form.choosen_max_power = null
                }
                $scope.saveChoosenData()
            }
        }

        $scope.updateMaxPower = () => {
            $scope.saveChoosenData()
        }

        $scope.saveChoosenData = function () {
            if (['BTINFLU', 'BTINFLUSC'].includes($scope.draft.draftElec.routing_tariff)) {
                $scope.draft.draftElec.choosen_routing_tariff = ($scope.form.choosen_id_p_calendar || $scope.draft.draftElec.id_p_calendar) === 'HPHC' ? 'BTINFMUDT' : 'BTINFCUST'
            }
            const id_p_calendar_modified = $scope.draft.draftElec.id_p_calendar !== $scope.form.choosen_id_p_calendar
            const max_power_modified = $scope.draft.draftElec.max_power !== $scope.form.choosen_max_power
            if (id_p_calendar_modified || max_power_modified) {
                $scope.saveDraft({
                    declared_cons: id_p_calendar_modified ? null : $scope.draft.declared_cons,
                    draftElec: {
                        choosen_id_p_calendar: id_p_calendar_modified ? $scope.form.choosen_id_p_calendar : null,
                        choosen_max_power: max_power_modified ? $scope.form.choosen_max_power : null,
                        choosen_routing_tariff: $scope.draft.draftElec.choosen_routing_tariff,
                    },
                })
            }
            MetaWatcher.notif('SALES_TUNNEL.UPDATED_CHOOSEN_DATA', {
                draftElec: {
                    choosen_max_power: $scope.form.choosen_max_power,
                    choosen_id_p_calendar: $scope.form.choosen_id_p_calendar,
                    choosen_routing_tariff: $scope.draft.draftElec.choosen_routing_tariff,
                },
            })
        }

        // PROVIDER OFFER
        const initAvailableRefProviderOffer = () => {
            OfferService.selectableOffersPromise.then((offersResult) => {
                if ($scope.draft.account_category === 'small-business') {
                    $scope.offers = offersResult.filter((offer) => {
                        return ['CAGNOTTE_TRV_PRO', 'CAGNOTTE_TRV_PRO_U'].includes(offer.value)
                    })
                } else {
                    $scope.offers = offersResult.filter((offer) => {
                        return !['CAGNOTTE_TRV_PRO', 'CAGNOTTE_TRV_PRO_U'].includes(offer.value)
                    })
                }
            }).catch(ErrorCatcher)
        }

        $scope.getProviderOfferLabel = (provider_offer) => _.get(_.find($scope.offers, { value: provider_offer }), 'label')

        $scope.changeOfferFields = {}
        $scope.changeOfferPayload = {}

        $scope.prepareUpdateRefProviderOffer = () => {
            $scope.changeOfferFields = {
                provider_offer: {
                    label: 'Offre fournisseur',
                    required: true,
                    type: 'select',
                    enum: $scope.offers,
                },
            }

            $scope.changeOfferPayload = {
                provider_offer: $scope.form.provider_offer,
            }
        }

        $scope.updateRefProviderOffer = () => {
            return DraftsBasic.modifyDraftOffer({ id_draft_basic: $scope.draft.id }, { provider_offer: $scope.changeOfferPayload.provider_offer }).$promise.then((result) => {
                if ($scope.changeOfferPayload.provider_offer === 'CAGNOTTE_TRV_PRO_U') {
                    // for systeme U we force the activation date to 1st of january
                    $scope.saveDraft({ desired_mes_date: '2021-01-01', bypass_retractation: true })
                } else {
                    MetaWatcher.notif('SALES_TUNNEL.RELOAD_DRAFT', {})
                    MetaWatcher.notif('SALES_TUNNEL.RELOAD_CONSENTS', {})
                }
            }).catch(ErrorCatcher)
        }

        // Send providerOffer fis to email
        $scope.providerOfferFisEmailPayload = {
            to: null,
            provider_offer: null,
        }

        $scope.providerOfferFisEmailFields = {
            to: {
                label: 'E-mail',
                type: 'email',
                required: true,
            },
        }

        $scope.updateProviderOfferFisEmail = () => {
            $scope.providerOfferFisEmailPayload.to = $scope.draft.mail
            $scope.providerOfferFisEmailPayload.provider_offer = $scope.draft.providerOffer.id
        }

        $scope.sendProviderOfferFisEmail = () => {
            $scope.sendingProviderOfferFis = true
            return ApiAdmin.sendProviderOfferFisToEmail($scope.providerOfferFisEmailPayload).$promise
            .then((result) => {
                AlertManager.success(`Grille tarifaire ${$scope.providerOfferFisEmailPayload.provider_offer} envoyée par e-mail à ${$scope.providerOfferFisEmailPayload.to}`)
            })
            .catch(ErrorCatcher)
            .finally(() => {
                $scope.sendingProviderOfferFis = false
            })
        }

        // PRM Form
        $scope.$watch('draft', (draft, previousDraft) => {
            const isAccountCategoryUpdated = $scope.draft.account_category && mapUtils.hasDifference(draft, previousDraft, ['account_category'])
            if (draft.draftElec.id_prm) {
                $scope.enedisConsent = true
            }
            $scope.form = {
                choosen_id_p_calendar: (draft.draftElec.choosen_id_p_calendar !== draft.draftElec.id_p_calendar) ? draft.draftElec.choosen_id_p_calendar : null,
                choosen_max_power: (draft.draftElec.choosen_max_power !== draft.draftElec.max_power) ? draft.draftElec.choosen_max_power : null,
                provider_offer: draft.draftElec.provider_offer,
                modify_offer: $scope.seniorAdvisor && ($scope.form.modify_offer || !!(
                    (draft.draftElec.choosen_id_p_calendar && draft.draftElec.id_p_calendar && draft.draftElec.choosen_id_p_calendar !== draft.draftElec.id_p_calendar) ||
                    (draft.draftElec.choosen_max_power && draft.draftElec.max_power && draft.draftElec.choosen_max_power !== draft.draftElec.max_power))
                ),
                primary_residence: draft.primary_residence,
                heating: draft.heating,
            }

            if ((draft.is_a_move !== previousDraft.is_a_move || !$scope.prm.prmResult) && _.get($scope, 'prm.id_prm.length') === 14) {
                $scope.fetchPrm()
            }
            if (isAccountCategoryUpdated) {
                initComponentValidator()
                initAvailableRefProviderOffer()
            }
            initChoosenCalendarData()
            initChoosenMaxPowerData()
        })

        const activate = function () {
            initComponentValidator()
            initChoosenCalendarData()
            initAvailableRefProviderOffer()

            // Fetch prm on init
            if (!_.isEmpty($scope.draft.draftElec.id_prm)) {
                $scope.fetchPrm()
            }
        }

        $scope.getDraftId = () => {
            return $scope.draft.id.startsWith('VD') ? $scope.draft.id : $scope.draft.draftElec.id
        }

        const scoreDraftInterest = () => {
            if ($scope.withoutPrm || $scope.disableDraftInterestScoring) {
                return Promise.resolve()
            }
            $scope.interestScoring = true
            return ApiUser.scoreDraftInterest({ idDraftElec: $scope.draft.draftElec.id }).$promise
            .then((result) => {
                $timeout(() => {
                    $scope.interestScore = result
                })
            })
            .catch(ErrorCatcher)
            .finally(() => {
                $scope.interestScoring = false
            })
        }

        MetaWatcher.watch('SALES_TUNNEL.DRAFT_INTEREST_SCORING_TRIGGER', 'salesTunnelPrm', $scope, () => {
            return scoreDraftInterest()
        })

        activate()
    },
}))
